import { updateLocale } from '@americanexpress/one-app-ducks';
import { getIsSupportedLocale } from '@americanexpress/rerouter';

const updateLocaleFromRoute = (store) => {
  const { dispatch } = store;

  return (nextState, replace, callback) => {
    const { params: { locale }, activeLocale } = nextState;
    if (!locale) {
      return callback();
    }
    const formattedLocale = locale.replace(
      /-([a-z]{2})/i,
      (match, group) => `-${group.toUpperCase()}`
    );
    if (getIsSupportedLocale(formattedLocale) && formattedLocale !== activeLocale) {
      return dispatch(updateLocale(formattedLocale))
        .then(callback);
    }

    return callback();
  };
};

export default updateLocaleFromRoute;
